module.exports = __webpack_public_path__ + "img/deletedStamp-removebg-preview.eb2cc584.png";